import { render, staticRenderFns } from "./ProxyEditForm.vue?vue&type=template&id=0ce845ce&scoped=true&"
import script from "./ProxyEditForm.vue?vue&type=script&lang=js&"
export * from "./ProxyEditForm.vue?vue&type=script&lang=js&"
import style0 from "./ProxyEditForm.vue?vue&type=style&index=0&id=0ce845ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce845ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ce845ce')) {
      api.createRecord('0ce845ce', component.options)
    } else {
      api.reload('0ce845ce', component.options)
    }
    module.hot.accept("./ProxyEditForm.vue?vue&type=template&id=0ce845ce&scoped=true&", function () {
      api.rerender('0ce845ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/ProxyEditForm.vue"
export default component.exports